import { defineEffect } from '../../../core/effect';
import { spsummoningSpec } from '../fx/spsummoning';

/** 特殊召喚（素材なし）の **effect**: 特殊召喚の軽い召喚バンク（今は全状況で同じ見せ方。組み立ては `../fx/spsummoning.js`） */
export default defineEffect({ situation: 'spsummoning_plain', role: 'effect', ...spsummoningSpec('spsummoning_plain') }, 'spsummoning_plain_effect.js');
